export default "__VITE_ASSET__DqFGt$WJ__"